export default __webpack_public_path__ + "static/media/portfolio-hover-163.659bf569.jpg";